/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T10:54:45.839
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentHouseHoldItem,
	getRentHouseHoldItemCreateInit,
	getRentHouseHoldItemEditInit,
	getRentHouseHoldItemView,
	deleteRentHouseHoldItem
} from '@api/rentmanage/RentHouseHoldItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentHouseHoldItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseHoldItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseHoldItem({}, RentHouseHoldItem) {
			return new Promise((resolve, reject) => {
				saveRentHouseHoldItem(RentHouseHoldItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseHoldItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseHoldItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseHoldItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseHoldItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
